export default "__VITE_ASSET__C3_0NRLV__"